var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoAndText(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 45,
    viewBox: "0 0 148 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_38350_206)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9992 41.7999C32.9345 41.7999 41.7992 32.9352 41.7992 22C41.7992 11.0647 32.9345 2.19995 21.9992 2.19995C11.064 2.19995 2.19922 11.0647 2.19922 22C2.19922 32.9352 11.064 41.7999 21.9992 41.7999Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2117 28.8878C25.7624 29.9867 23.9563 30.6399 21.9971 30.6399C20.0278 30.6399 18.2136 29.98 16.7607 28.8706L12.3691 33.2139C14.9562 35.437 18.3184 36.7839 21.9971 36.7839C25.6588 36.7839 29.007 35.4497 31.5892 33.2448L27.2117 28.8878Z",
    fill: "#00B2FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3839 19.9176C30.5489 20.5845 30.6377 21.2811 30.6377 21.9986C30.6377 23.9437 29.9948 25.7383 28.9102 27.1822L33.287 31.5388C35.5324 28.8813 36.7823 25.5039 36.7823 21.9986C36.7823 19.6088 36.1995 17.2755 35.1152 15.1868L30.3839 19.9176Z",
    fill: "#FF4F42"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.068 27.1626C13.9932 25.7223 13.357 23.9365 13.357 22.0011C13.357 17.2293 17.2253 13.3611 21.997 13.3611C23.3768 13.3611 24.6799 13.686 25.837 14.2614L30.2991 9.7989C27.9259 8.17286 25.0645 7.2168 21.997 7.2168C13.8865 7.2168 7.21289 13.8907 7.21289 22.0011C7.21289 25.4894 8.45055 28.852 10.6776 31.5047L15.068 27.1626Z",
    fill: "#17C22E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1476 25.5554C20.763 25.5554 20.3779 25.4086 20.0846 25.115L17.1807 22.2113C16.5934 21.6242 16.5934 20.6724 17.1807 20.0855C17.7673 19.4982 18.7197 19.4982 19.3066 20.0855L21.1476 21.926L32.8948 10.179C33.4815 9.5917 34.4341 9.5917 35.0209 10.179C35.6082 10.7659 35.6082 11.718 35.0209 12.3051L22.2104 25.115C21.9171 25.4086 21.5322 25.5554 21.1476 25.5554Z",
    fill: "#34393D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0718 29.2302H58.426V19.1755H62.8982V15.8564L50.5996 15.824V19.1755H55.0718V29.2302Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8426 26.9958L68.4885 22.5494V29.2302H65.1343V15.824L67.3704 15.8564L71.8426 21.4099L76.3148 15.8564L78.551 15.824V29.2302H75.1968V22.5494L71.8426 26.9958Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8496 23.6443H85.2593V26.3894H93.0857V29.2626L81.9051 29.2626V15.824H93.0857V18.6169H85.2593V21.4099H90.8496V23.6443Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.447 25.8787H113.211V29.2626H109.856V15.824H116.006C119.36 15.824 121.596 17.4942 121.596 20.8513C121.596 23.0801 119.919 24.7615 118.801 25.3201L122.155 29.2302H118.242L115.447 25.8787ZM118.242 20.8513C118.242 19.1755 117.124 18.6169 115.447 18.6169H113.211V23.06L115.447 23.0857C117.124 23.0857 118.242 22.5271 118.242 20.8513Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M125.509 29.2302V15.824H128.863V29.2302H125.509Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M103.148 29.2626L99.794 29.2626V19.2079H95.3218V15.8564H107.62V19.2079H103.148V29.2626Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M145.09 27.186C143.758 28.7241 141.774 29.6994 139.559 29.6994C135.546 29.6994 132.293 26.4982 132.293 22.5494C132.293 18.6006 135.546 15.3994 139.559 15.3994C141.773 15.3994 143.756 16.3739 145.089 17.9108L142.51 20.0101C141.809 19.1237 140.748 18.5588 139.56 18.5588C137.448 18.5588 135.735 20.3455 135.735 22.5495C135.735 24.7535 137.448 26.5402 139.56 26.5402C140.748 26.5402 141.81 25.9743 142.512 25.0867L145.09 27.186Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_38350_206",
    x: 0.199219,
    y: 0.699951,
    width: 43.5996,
    height: 43.6001,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0578824 0 0 0 0 0.109333 0 0 0 0 0.160784 0 0 0 0.32 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_38350_206"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_38350_206",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAndText);
export default __webpack_public_path__ + "static/media/logo_and_text.fc5aec49d1c00794a89cb92a6a2296b3.svg";
export { ForwardRef as ReactComponent };